/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function () {
	const salesforceElements = document.querySelectorAll(
		".main-form__salesforce",
	);
	if (salesforceElements) {
		salesforceElements.forEach((element) => {
			const formId = element.getAttribute("data-form-id");
			const thankyouLink = element.getAttribute("data-completion-link");
			if (formId) {
				const sdkScript = document.createElement("script");
				sdkScript.src = `https://f.edology.com/sdk.js?hash=${formId}`;
				sdkScript.defer = true;
				sdkScript.id = "jForm";
				if(thankyouLink){
					sdkScript.setAttribute("data-finish", thankyouLink);
				}
				element.appendChild(sdkScript);
			}
		});
	}
});
